/* Kosbiotic theme runtime — vanilla JS (substitui Alpine da referência) */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const isDesktop = () => window.matchMedia('(min-width: 64rem)').matches;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveal lines (x-reveal-lines) ---------- */
  function splitWords(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) if (walker.currentNode.nodeValue.trim()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      const frag = document.createDocumentFragment();
      node.nodeValue.split(/(\s+)/).forEach((part) => {
        if (!part) return;
        if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
        const w = document.createElement('span'); w.className = 'reveal-lines__word';
        const i = document.createElement('span'); i.className = 'reveal-lines__word-inner'; i.textContent = part;
        w.appendChild(i); frag.appendChild(w);
      });
      node.parentNode.replaceChild(frag, node);
    });
  }
  function indexLines(root) {
    let line = -1, lastTop = null;
    $$('.reveal-lines__word', root).forEach((w) => {
      const t = w.offsetTop;
      if (lastTop === null || Math.abs(t - lastTop) > 4) { line++; lastTop = t; }
      w.style.setProperty('--reveal-lines-index', line);
    });
  }
  const revealIO = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-visible');
      revealIO.unobserve(e.target);
      setTimeout(() => $$('.reveal-lines__word', e.target).forEach((w) => w.classList.add('is-done')), 2200);
    });
  }, { threshold: 0.15 });
  function initReveal(scope = document) {
    $$('[x-reveal-lines]:not(.reveal-lines)', scope).forEach((el) => {
      if (reduced || window.Shopify?.designMode) { el.classList.add('reveal-lines', 'is-visible'); return; }
      splitWords(el); el.classList.add('reveal-lines'); indexLines(el); revealIO.observe(el);
    });
  }

  /* ---------- Lazyload pictures ---------- */
  function initPictures(scope = document) {
    $$('.picture--lazyload:not(.is-loaded)', scope).forEach((p) => {
      const img = $('img', p); if (!img) return;
      const scrollReveal = p.closest('.slice-diptych-parallax, .blank.philosophy-diptychs, .blank.philosophy-rollout-image');
      const done = () => { p.classList.add('is-loaded'); if (!scrollReveal) p.classList.add('is-revealed'); };
      if (img.complete && img.naturalWidth) done(); else { img.addEventListener('load', done, { once: true }); img.addEventListener('error', done, { once: true }); }
    });
  }

  /* ---------- Parallax ---------- */
  let parallaxEls = [];
  function initParallax(scope = document) {
    if (reduced) return;
    $$('.picture--parallax, .video--parallax', scope).forEach((el) => { el.classList.add('is-parallax-active'); parallaxEls.push(el); });
    updateParallax();
  }
  function updateParallax() {
    const vh = window.innerHeight;
    parallaxEls.forEach((el) => {
      const r = el.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      const p = ((r.top + r.height / 2) - vh / 2) / (vh / 2 + r.height / 2);
      el.style.setProperty('--parallax-progress', Math.max(-1, Math.min(1, p)).toFixed(4));
    });
  }

  /* ---------- Videos ---------- */
  function initVideos(scope = document) {
    const io = new IntersectionObserver((entries) => entries.forEach((e) => {
      const v = e.target;
      if (e.isIntersecting) { v.play().catch(() => {}); } else if (!v.paused) v.pause();
    }), { threshold: 0.1 });
    $$('video[data-autoplay], video.video__el', scope).forEach((v) => {
      v.muted = true; v.playsInline = true;
      v.addEventListener('playing', () => { v.classList.add('is-revealed'); const w = v.closest('.video'); w?.classList.add('is-playing'); const pv = $('.video__preview', w); if (pv) pv.style.display = 'none'; }, { once: true });
      io.observe(v);
    });
    $$('.video__toggle', scope).forEach((b) => b.addEventListener('click', (ev) => {
      ev.preventDefault(); const v = $('video', b.closest('.video')); if (!v) return;
      v.paused ? v.play() : v.pause(); b.setAttribute('aria-pressed', v.paused);
      const [play, pause] = $$('span[aria-hidden]', b); if (play && pause) { play.style.display = v.paused ? '' : 'none'; pause.style.display = v.paused ? 'none' : ''; }
    }));
  }

  /* ---------- Accordion ---------- */
  function initAccordions(scope = document) {
    $$('.accordion > .accordion__header', scope).forEach((btn) => {
      if (btn.dataset.kbBound) return; btn.dataset.kbBound = '1';
      btn.addEventListener('click', () => {
        const acc = btn.parentElement; const panel = $(':scope > .accordion__panel', acc);
        const open = !acc.classList.contains('is-active');
        const group = acc.dataset.accordionGroup;
        if (open && group) $$(`.accordion.is-active[data-accordion-group="${group}"]`).forEach((o) => { if (o !== acc) toggle(o, false); });
        toggle(acc, open);
      });
    });
    function toggle(acc, open) {
      const panel = $(':scope > .accordion__panel', acc); const btn = $(':scope > .accordion__header', acc);
      acc.classList.toggle('is-active', open); btn.setAttribute('aria-expanded', open);
      if (!panel) return;
      panel.removeAttribute('x-cloak'); panel.style.overflow = 'hidden';
      const h = panel.scrollHeight;
      panel.style.transition = 'height 250ms var(--animation-easing-smooth, ease)';
      if (open) { panel.style.display = 'block'; panel.style.height = '0px'; requestAnimationFrame(() => { panel.style.height = panel.scrollHeight + 'px'; }); setTimeout(() => { panel.style.height = ''; panel.style.overflow = ''; }, 260); }
      else { panel.style.height = h + 'px'; requestAnimationFrame(() => { panel.style.height = '0px'; }); setTimeout(() => { panel.style.display = 'none'; panel.style.height = ''; }, 260); }
      panel.setAttribute('aria-hidden', !open);
    }
  }

  /* ---------- Drawers (menu mobile / cart) ---------- */
  const backdrop = document.createElement('div');
  backdrop.className = 'overlay__backdrop';
  document.addEventListener('DOMContentLoaded', () => $('#overlays-container')?.appendChild(backdrop));
  let openDrawer = null;
  function open(id) {
    const d = document.getElementById(id); if (!d) return;
    if (openDrawer && openDrawer !== d) close(openDrawer, true);
    d.classList.remove('is-closing'); d.inert = false; d.classList.add('is-open'); openDrawer = d;
    backdrop.classList.add('is-active'); document.documentElement.style.overflow = 'hidden';
    $$(`[aria-controls="${id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
  }
  function close(d = openDrawer, swap = false) {
    if (!d) return;
    d.classList.add('is-closing'); d.classList.remove('is-open');
    setTimeout(() => { d.classList.remove('is-closing'); d.inert = true; }, 500);
    $$(`[aria-controls="${d.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (!swap) { backdrop.classList.remove('is-active'); document.documentElement.style.overflow = ''; openDrawer = null; }
  }
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-drawer-open]'); if (t) { e.preventDefault(); if (t.dataset.drawerOpen === 'clinical-studies-drawer') selectStudy(t.dataset.study); open(t.dataset.drawerOpen); return; }
    if (e.target.closest('[data-drawer-close]') || e.target === backdrop) close();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { close(); closePanel(); } });
  window.KBDrawer = { open, close };

  /* ---------- Header ---------- */
  const header = () => $('.header');
  let lastY = window.scrollY;
  function headerColor() {
    const h = header(); if (!h) return;
    const y = h.getBoundingClientRect().bottom - 2;
    const els = document.elementsFromPoint(window.innerWidth / 2, Math.max(y, 1));
    const target = els.find((el) => !el.closest('.section-header') && el.closest('[data-header-color]'));
    const host = target?.closest('[data-header-color]');
    const mobile = !isDesktop();
    const c = host ? (mobile ? host.dataset.headerColorMobile || host.dataset.headerColor : host.dataset.headerColor) : 'black';
    document.body.style.setProperty(mobile ? '--header-floating-color-mobile' : '--header-floating-color-desktop', c === 'black' ? 'var(--color-black)' : 'var(--color-white)');
    // fundo branco quando a seção sob o header não é "floating" (sem data-header-color)
    h.classList.toggle('is-active', !host && window.scrollY > 10);
  }
  function onScroll() {
    const y = window.scrollY; const h = header();
    if (h && !h.classList.contains('is-panel-open') && !openDrawer) {
      const goingDown = y > lastY && y > 200;
      h.classList.toggle('is-hidden', goingDown && h.dataset.hideOnScroll === 'true');
    }
    lastY = y; headerColor(); updateParallax();
  }
  window.addEventListener('scroll', () => requestAnimationFrame(onScroll), { passive: true });
  window.addEventListener('resize', () => { headerColor(); updateParallax(); });

  /* Mega menu desktop */
  let activePanel = null, closeTimer = null;
  function openPanel(i) {
    clearTimeout(closeTimer);
    const h = header(); const panel = $('.menu-panel', h); if (!panel) return;
    const inner = $(`.menu-panel__inner[data-menu-desktop-panel="${i}"]`, panel);
    if (!inner) { closePanel(); return; }
    const dir = activePanel === null ? 0 : (i > activePanel ? 1 : -1);
    $$('.menu-panel__inner', panel).forEach((p) => { const on = p === inner; p.classList.toggle('is-open', on); p.inert = !on; p.setAttribute('aria-hidden', !on); p.style.setProperty('--direction', on ? 0 : -dir); });
    panel.classList.add('is-open'); h.classList.add('is-panel-open');
    panel.style.setProperty('--menu-desktop-panel-active-panel-height', inner.offsetHeight + 'px');
    $$('.menu-desktop__item', h).forEach((li, k) => li.classList.toggle('is-active', +li.dataset.index === i));
    $$('[data-panel-trigger]', h).forEach((b) => b.setAttribute('aria-expanded', +b.dataset.panelTrigger === i));
    activePanel = i;
  }
  function closePanel(delay = 0) {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(() => {
      const h = header(); if (!h) return; const panel = $('.menu-panel', h);
      panel?.classList.remove('is-open'); panel?.style.setProperty('--menu-desktop-panel-active-panel-height', '0px');
      $$('.menu-panel__inner', panel || h).forEach((p) => { p.classList.remove('is-open'); p.inert = true; });
      h.classList.remove('is-panel-open'); $$('.menu-desktop__item', h).forEach((li) => li.classList.remove('is-active'));
      $$('[data-panel-trigger]', h).forEach((b) => b.setAttribute('aria-expanded', 'false'));
      activePanel = null; hideIndicator();
    }, delay);
  }
  function moveIndicator(el) {
    const list = $('.menu-desktop__list'); if (!list || !el) return;
    const r = el.getBoundingClientRect(), lr = list.getBoundingClientRect();
    list.style.setProperty('--indicator-left', r.left - lr.left + 'px'); list.style.setProperty('--indicator-width', r.width + 'px'); list.style.setProperty('--indicator-opacity', 1);
  }
  function hideIndicator() { $('.menu-desktop__list')?.style.setProperty('--indicator-opacity', 0); }
  function moveActionIndicator(el) {
    const wrap = $('.header__actions--right'); if (!wrap || !el) return;
    const r = el.getBoundingClientRect(), wr = wrap.getBoundingClientRect(); const pad = parseFloat(getComputedStyle(el).paddingLeft) || 0;
    wrap.style.setProperty('--indicator-left', r.left - wr.left + pad + 'px'); wrap.style.setProperty('--indicator-width', r.width - pad * 2 + 'px'); wrap.style.setProperty('--indicator-opacity', 1);
  }
  function initHeader() {
    const h = header(); if (!h) return;
    $$('.menu-desktop__item', h).forEach((li) => {
      const i = +li.dataset.index; const hasPanel = !!$(`.menu-panel__inner[data-menu-desktop-panel="${i}"]`, h);
      li.addEventListener('mouseenter', () => (hasPanel ? openPanel(i) : closePanel()));
      li.addEventListener('mouseover', (e) => moveIndicator(e.target.closest('.menu-link__label')));
      const btn = $('[data-panel-trigger]', li);
      btn?.addEventListener('click', () => (activePanel === i ? closePanel() : openPanel(i)));
      btn?.addEventListener('keydown', (e) => { if (e.key === 'ArrowDown' || e.key === 'Enter') { e.preventDefault(); openPanel(i); } });
    });
    $('.menu-desktop__list', h)?.addEventListener('mouseleave', () => closePanel(150));
    const panel = $('.menu-panel', h);
    panel?.addEventListener('mouseenter', () => clearTimeout(closeTimer));
    panel?.addEventListener('mouseleave', () => closePanel(100));
    $$('.menu-panel__product-link', h).forEach((a) => {
      a.addEventListener('mouseenter', () => $$(`.menu-panel__media-item`, h).forEach((m) => m.classList.toggle('is-active', m.dataset.product === a.dataset.product)));
      a.addEventListener('mouseleave', () => $$(`.menu-panel__media-item`, h).forEach((m) => m.classList.remove('is-active')));
    });
    const actions = $('.header__actions--right', h);
    actions?.addEventListener('mouseover', (e) => moveActionIndicator(e.target.closest('.header__action')));
    actions?.addEventListener('mouseleave', () => actions.style.setProperty('--indicator-opacity', 0));
    headerColor();
  }

  /* ---------- Carousels nativos (scroll-snap) ---------- */
  function initCarousels(scope = document) {
    $$('[data-kb-carousel]', scope).forEach((c) => {
      if (c.dataset.kbBound) return; c.dataset.kbBound = '1';
      const vp = $('.carousel__viewport', c) || c; const slides = $$('.carousel__slide', c);
      const dots = $$('[data-carousel-dot]', c.parentElement); const prev = $('[data-carousel-prev]', c.parentElement); const next = $('[data-carousel-next]', c.parentElement);
      const go = (i) => { const s = slides[Math.max(0, Math.min(slides.length - 1, i))]; if (s) vp.scrollTo({ left: s.offsetLeft - slides[0].offsetLeft, behavior: 'smooth' }); };
      const current = () => { let best = 0, d = Infinity; slides.forEach((s, i) => { const dd = Math.abs(s.offsetLeft - slides[0].offsetLeft - vp.scrollLeft); if (dd < d) { d = dd; best = i; } }); return best; };
      const bar = $('.carousel__progress-bar', c);
      vp.addEventListener('scroll', () => { const i = current(); dots.forEach((d, k) => d.classList.toggle('is-active', k === i)); if (bar) { const max = vp.scrollWidth - vp.clientWidth; const vis = vp.clientWidth / vp.scrollWidth; bar.style.transform = `scaleX(${Math.min(1, vis + (max > 0 ? vp.scrollLeft / max : 1) * (1 - vis))})`; } c.dispatchEvent(new CustomEvent('kb:slide', { detail: i })); }, { passive: true });
      dots.forEach((d, k) => d.addEventListener('click', () => go(k)));
      prev?.addEventListener('click', () => go(current() - 1)); next?.addEventListener('click', () => go(current() + 1));
      if (bar) { const vis = vp.clientWidth / vp.scrollWidth; bar.style.transform = `scaleX(${Math.min(1, vis)})`; }
      c.classList.add('is-initialized');
    });
  }

  /* ---------- Cart drawer (Section Rendering API) ---------- */
  async function refreshCartDrawer(openAfter = false) {
    const cur = document.getElementById('cart-drawer'); if (!cur) return;
    const sid = cur.dataset.kbCartSection;
    try {
      const html = (await (await fetch(`${KB.routes.root}?sections=${sid}`)).json())[sid];
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.getElementById('cart-drawer'); if (!fresh) return;
      const wasOpen = cur.classList.contains('is-open');
      cur.innerHTML = fresh.innerHTML;
      if (wasOpen || openAfter) { cur.inert = false; }
      init(cur);
    } catch (e) {}
  }
  async function changeLine(key, quantity) {
    const d = document.getElementById('cart-drawer'); d?.classList.add('is-loading');
    await fetch(KB.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
    await refreshCartCount(); await refreshCartDrawer(); d?.classList.remove('is-loading');
  }
  document.addEventListener('change', (e) => { const q = e.target.closest('[data-kb-line-qty]'); if (q) changeLine(q.dataset.kbLineQty, +q.value); });
  document.addEventListener('click', (e) => { const r = e.target.closest('[data-kb-remove]'); if (r) { e.preventDefault(); changeLine(r.dataset.kbRemove, 0); } });
  document.addEventListener('kb:cart:refresh', () => refreshCartDrawer(true));

  /* ---------- Cart ---------- */
  async function refreshCartCount() {
    try { const c = await (await fetch(KB.routes.cart + '.js')).json(); $$('[data-cart-count]').forEach((el) => (el.textContent = `(${c.item_count})`)); return c; } catch (e) {}
  }
  document.addEventListener('submit', async (e) => {
    const f = e.target.closest('form[data-kb-add-to-cart], form.add-to-cart-form__form'); if (!f) return;
    e.preventDefault(); const btn = $('[type="submit"]', f); btn?.classList.add('is-loading'); btn && (btn.disabled = true);
    try {
      const fd = new FormData(f); if (!fd.get('selling_plan')) fd.delete('selling_plan');
      const r = await fetch(KB.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd });
      if (!r.ok) throw new Error((await r.json()).description);
      await refreshCartCount(); document.dispatchEvent(new CustomEvent('kb:cart:added'));
      if (document.getElementById('cart-drawer')) { await refreshCartDrawer(true); open('cart-drawer'); } else window.location.href = KB.routes.cart;
    } catch (err) { alert(err.message || 'Erreur'); }
    finally { btn?.classList.remove('is-loading'); btn && (btn.disabled = false); }
  });

  /* ---------- PDP ---------- */
  function initProduct(scope = document) {
    $$('.product-header', scope).forEach((ph) => {
      const qs = $$('[data-kb-qty]', ph);
      // Preço do botão = preço unitário (plano ou compra única) × quantidade
      // Faixas de desconto por quantidade (espelham os descontos automáticos da loja)
      const tiers = $$('[data-kb-tiers] li', ph).map((li) => ({ li, min: +li.dataset.min, pct: +li.dataset.pct }));
      const fmt = (c) => (c / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' €';
      const updatePrice = () => {
        const qty = parseInt(qs[0]?.value, 10) || 1;
        const tier = tiers.filter((t) => qty >= t.min).sort((a, b) => b.min - a.min)[0];
        tiers.forEach((t) => t.li.classList.toggle('is-active', t === tier));
        $$('[data-kb-price]', ph).forEach((el) => {
          const unit = parseInt(el.dataset.kbUnit, 10); if (isNaN(unit)) return;
          const full = unit * qty; const final = tier ? Math.round(full * (100 - tier.pct) / 100) : full;
          el.textContent = fmt(final);
          const cmp = el.parentElement.querySelector('[data-kb-compare]');
          if (cmp) { cmp.textContent = fmt(full); cmp.hidden = final >= full; }
        });
        // "1 mois de cure" → "[q] mois de cure"; preço à direita vira preço por mês (cheio riscado se houver desconto)
        $$('[data-kb-cure]', ph).forEach((el) => (el.textContent = qty > 1 ? el.dataset.many.replace('[q]', qty) : el.dataset.one));
        $$('[data-kb-month]', ph).forEach((el) => {
          const unit = +el.dataset.cents; const per = tier ? Math.round(unit * (100 - tier.pct) / 100) : unit;
          const f = (c) => fmt(c).replace(' €', '€');
          el.innerHTML = per < unit ? `<s class="kb-compare">${f(unit)}</s>${f(per)}${qty > 1 ? ' ' + el.dataset.suffix : ''}` : f(unit) + (qty > 1 ? ' ' + el.dataset.suffix : '');
        });
      };
      $$('.options-picker-selling-plan__option-radio', ph).forEach((r) => r.addEventListener('change', () => {
        $$('[data-kb-price]', ph).forEach((el) => (el.dataset.kbUnit = r.dataset.cents));
        $$('[data-kb-suffix]', ph).forEach((el) => (el.textContent = r.dataset.suffix ? ' ' + r.dataset.suffix : ''));
        updatePrice();
      }));
      qs.forEach((q) => q.addEventListener('change', () => { qs.forEach((o) => (o.value = q.value)); updatePrice(); }));
      updatePrice();
      const sticky = $('[data-kb-sticky]', ph); const main = $('.block-add-to-cart', ph);
      if (sticky && main) {
        new IntersectionObserver(([e]) => sticky.classList.toggle('is-active', !e.isIntersecting && e.boundingClientRect.top < 0), { threshold: 0 }).observe(main);
      }
    });
  }

  /* ---------- Badges numerados (0.1, 0.2…) e números animados ---------- */
  function initBadges() {
    let n = 0;
    $$('[data-badge-indexed]').forEach((sec) => {
      const pre = $('[data-badge-index-prefix]', sec); if (!pre) return;
      if (sec.dataset.noIndex === 'true') { pre.textContent = ''; return; }
      n++; pre.textContent = `0.${n}\u00a0`;
    });
  }
  const figIO = new IntersectionObserver((entries) => entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-revealed'); figIO.unobserve(e.target); } }), { threshold: 0.3 });
  function initFigures(scope = document) { $$('.figure-text__value--animated', scope).forEach((el) => figIO.observe(el)); }

  /* ---------- Páginas: abas, ingredientes, blog, estudos, contato ---------- */
  function selectStudy(key) {
    const d = document.getElementById('clinical-studies-drawer'); if (!d) return;
    const tabs = $$('.clinical-studies-drawer__tab', d);
    let tab = key ? tabs.find((t) => t.dataset.studyKey === key) : null;
    if (!tab) { const h = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1]; if (h) tab = tabs.find((t) => (t.dataset.products || '').split(/[\s,]+/).includes(h)); }
    tab = tab || tabs[0]; if (!tab) return;
    tabs.forEach((t) => { const on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on); });
    $$('.clinical-studies-drawer__study', d).forEach((a) => (a.hidden = a.dataset.studyKey !== tab.dataset.studyKey));
    const list = $('.clinical-studies-drawer__tabs', d);
    if (list) { list.style.setProperty('--indicator-left', tab.offsetLeft + 'px'); list.style.setProperty('--indicator-width', tab.offsetWidth + 'px'); list.style.setProperty('--indicator-opacity', 1); }
  }
  document.addEventListener('click', (e) => { const t = e.target.closest('.clinical-studies-drawer__tab'); if (t) selectStudy(t.dataset.studyKey); });

  function initPages(scope = document) {
    $$('[data-kb-tabs]', scope).forEach((sec) => {
      if (sec.dataset.kbBound) return; sec.dataset.kbBound = '1';
      $$('.slice-tabs__tab', sec).forEach((b) => b.addEventListener('click', () => {
        const i = b.dataset.tab;
        $$('.slice-tabs__tab', sec).forEach((x) => { const on = x === b; x.classList.toggle('is-active', on); x.setAttribute('aria-selected', on); });
        $$('[data-tab-panel]', sec).forEach((p) => p.classList.toggle('is-active', p.dataset.tabPanel === i));
      }));
    });
    $$('[data-kb-ingredients]', scope).forEach((sec) => {
      if (sec.dataset.kbBound) return; sec.dataset.kbBound = '1';
      const step = +sec.dataset.step || 16; let shown = step; let tab = 'all';
      const items = $$('[data-ingredient-item]', sec); const more = $('[data-ingredients-more]', sec); const count = $('[data-ingredients-count]', sec);
      const render = () => {
        const match = items.filter((li) => tab === 'all' || (li.dataset.products || '').split(' ').includes(tab));
        items.forEach((li) => (li.hidden = true)); match.forEach((li, k) => (li.hidden = k >= shown));
        if (count) count.textContent = match.length; if (more) more.parentElement.style.display = match.length <= shown ? 'none' : '';
      };
      $$('.ingredients__tab', sec).forEach((b) => b.addEventListener('click', () => { tab = b.dataset.tab; shown = step; $$('.ingredients__tab', sec).forEach((x) => x.classList.toggle('is-active', x === b)); render(); }));
      more?.addEventListener('click', () => { shown += step; render(); });
    });
    $$('[data-kb-article-grid]', scope).forEach((sec) => {
      if (sec.dataset.kbBound) return; sec.dataset.kbBound = '1';
      const step = +sec.dataset.step || 9; let shown = step; const body = $('.article-grid__body', sec); const more = $('[data-kb-article-more]', sec);
      const render = () => { $$('.article-card', body).forEach((c, k) => { c.classList.toggle('is-hidden', k >= shown); const m = k % 6; c.classList.toggle('article-card--big', m === 2 || m === 3); c.classList.toggle('article-card--small', !(m === 2 || m === 3)); }); if (more) more.parentElement.style.display = $$('.article-card', body).length <= shown ? 'none' : ''; };
      more?.addEventListener('click', () => { shown += step; render(); });
      $('[data-kb-article-sort]', sec)?.addEventListener('change', (e) => { const cards = $$('.article-card', body); cards.sort((a, b) => (e.target.value === 'oldest' ? 1 : -1) * a.dataset.date.localeCompare(b.dataset.date)); cards.forEach((c) => body.appendChild(c)); render(); });
    });
    $$('[data-kb-subject]', scope).forEach((sel) => {
      const form = sel.closest('form'); const order = $('[data-kb-order]', form); const star = $('[data-kb-order-required]', form);
      sel.addEventListener('change', () => { const req = sel.selectedOptions[0]?.dataset.requiresOrderNumber === 'true'; if (order) order.required = req; if (star) star.hidden = !req; });
    });
    $$('.slice-diptych-parallax .picture--lazyload, .blank.philosophy-diptychs .picture--lazyload, .blank.philosophy-rollout-image .picture--lazyload', scope).forEach((p) => revealIO2.observe(p));
  }
  const revealIO2 = new IntersectionObserver((entries) => entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-revealed'); revealIO2.unobserve(e.target); } }), { threshold: 0.2 });

  /* ---------- Boot ---------- */
  function init(scope = document) { initPages(scope); initBadges(); initFigures(scope); initProduct(scope); initReveal(scope); initPictures(scope); initParallax(scope); initVideos(scope); initAccordions(scope); initCarousels(scope); }
  function teleportDrawers() {
    const host = $('#overlays-container'); if (!host) return;
    if (backdrop.parentElement !== host) host.appendChild(backdrop);
    ['menu-mobile', 'cart-drawer', 'clinical-studies-drawer'].forEach((id) => { const d = document.getElementById(id); if (d && d.parentElement !== host) host.appendChild(d); });
  }
  function boot() { teleportDrawers(); initHeader(); init(); onScroll(); if (document.body.classList.contains('template-cart') && document.getElementById('cart-drawer')) open('cart-drawer'); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('load', () => $$('.reveal-lines').forEach(indexLines));
  // Theme Editor
  document.addEventListener('shopify:section:load', (e) => { [...document.querySelectorAll('#overlays-container > #menu-mobile, #overlays-container > #cart-drawer, #overlays-container > #clinical-studies-drawer')].forEach((d) => { if (e.target.querySelector('#' + d.id)) d.remove(); }); teleportDrawers(); parallaxEls = []; if (e.target.querySelector('.header')) initHeader(); init(e.target); initParallax(); });
  document.addEventListener('shopify:block:select', (e) => initReveal(e.target));
  window.KBInit = init;
})();
